import React from "react";

const Context = React.createContext({
    getAllCars: [],
    getSearch: {},
    getSelected: {},
    images: [],
    tagSelectedAdmin: "עריכת רכבים",
    api_url: "",
    delete_car: "",
    tabSelectedUser: "חיפוש רכבים",
    getBanner: [],
    getReviews: [],
    getFavCars: false,
    getArrFavCars: [],
    setAllCars: (cars) => { },
    setSearch: (search) => { },
    setSelected: (selectedCar) => { },
    setTabSelectedAdmin: () => "",
    setTabSelectedUser: () => { },
    setDeleteCar: () => "",
    setBanner: () => { },
    setReviews: (data) => { },
    setFavCars: (value) => { },
    setArrFavCars: (arr) => { }

});

export default Context;